import type { SVGProps } from 'react';
const SvgTickets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="m8.359 4.625-.606.14A1.85 1.85 0 0 1 6.34 6.987a1.895 1.895 0 0 1-2.237-1.43l-1.212.25a1.26 1.26 0 0 0-.947 1.553s.559 2.594 1.212 5.515M20.01 4.61a2.05 2.05 0 0 1-3.395.752 2.05 2.05 0 0 1-.396-2.306l-1.258-.59a1.383 1.383 0 0 0-1.803.73L7.94 15.485l-.683 1.553a1.38 1.38 0 0 0 .73 1.802l6.308 2.688a1.383 1.383 0 0 0 1.802-.73l5.903-13.889a1.38 1.38 0 0 0-.668-1.756z"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
    />
  </svg>
);
export default SvgTickets;
